// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"2c2e8db0","787":"ee291ec2"}[chunkId] + ".chunk.js";
};